import { CharacterAttack } from '../attacks/CharacterAttack';
import { CharacterBase } from '../CharacterBase';
import { CharacterEnemy } from '../CharacterEnemy';
const CONFIG = {
  id: 'ultralak',
  spineid: 'ultralak',
  combatStyle: 'MELEE',
  speed: 200,
  health: 700,
  coins: 10,
  stagger: false,
  knockdown: false,
  attackRate: 3.5,
  attackRange: 250,
  attacks: [],
  bodyCollider: { width: 100, height: 250 },
};
const ATTACKS = {
  combo_1: {
    id: 'combo_1',
    name: 'combo_1',
    animation: 'attack_1',
    damage: 20,
  },
  combo_2: {
    id: 'combo_2',
    name: 'combo_2',
    animation: 'attack_2',
    damage: 20,
  },
  combo_3: {
    id: 'combo_3',
    name: 'combo_3',
    animation: 'combo_finisher',
    damage: 40,
    knockdown: true,
  },
  laser_spear_cleave: {
    id: 'laser_spear_cleave',
    name: 'laser_spear_cleave',
    animation: 'laser_spear_cleave',
    damage: 50,
    knockdown: true,
  },
  laser_spear_1: {
    id: 'laser_spear_1',
    name: 'laser_spear_1',
    animation: 'laser_spear_attack_1',
    damage: 30,
  },
  laser_spear_2: {
    id: 'laser_spear_2',
    name: 'laser_spear_2',
    animation: 'laser_spear_attack_2',
    damage: 30,
  },
  laser_spear_3: {
    id: 'laser_spear_3',
    name: 'laser_spear_3',
    animation: 'laser_spear_combo_finisher',
    damage: 50,
    knockdown: true,
  },
};
export class CharacterUltralak extends CharacterEnemy {
  constructor(scene, x, y, config, collisionmap) {
    super(scene, x, y, CONFIG, collisionmap);
    this._attacks = {};
    Object.keys(ATTACKS).forEach((key) => {
      this._attacks[key] = new CharacterAttack(scene, this, ATTACKS[key]);
    });
    this._grabbable = false;
    this.attackCount = -1;
    this.attackPattern = ['combo_1', 'combo_1', 'laser_spear_1'];
    this.isBoss = true;
  }

  chooseAttack() {
    if (this._heroTarget.isJumping) {
      return this._attacks['laser_spear_cleave'];
    }
    this.attackCount++;
    return this._attacks[this.attackPattern[this.attackCount % this.attackPattern.length]];
  }

  handleAttackComplete() {
    switch (this._attackActive) {
      case this._attacks['combo_1']:
        this._attackActive = this._attacks['combo_2'];
        this._attackActive.trigger();
        this.setState(CharacterBase.STATES.ATTACK);
        break;
      case this._attacks['combo_2']:
        this._attackActive = this._attacks['combo_3'];
        this._attackActive.trigger();
        this.setState(CharacterBase.STATES.ATTACK);
        break;
      case this._attacks['laser_spear_1']:
        this._attackActive = this._attacks['laser_spear_2'];
        this._attackActive.trigger();
        this.setState(CharacterBase.STATES.ATTACK);
        break;
      case this._attacks['laser_spear_2']:
        this._attackActive = this._attacks['laser_spear_3'];
        this._attackActive.trigger();
        this.setState(CharacterBase.STATES.ATTACK);
        break;
      default:
        super.handleAttackComplete();
    }
  }
}
